@if (node() && editable && formGroup()) {
<div class="site-panel">
    <form class="site-form" [formGroup]="formGroup()!" (ngSubmit)="onSubmit()">
        <div class="header">
            <ul class="tabs">
                @for (tab of tabs; track tab.caption) {
                <li class="tab" [hidden]="tab.hidden">
                    <a class="tab-link" (click)="onClick(tab)" [ngClass]="{'active': tabSelected === tab}">{{tab.caption}}</a>
                </li>
                }
            </ul>
        </div>
        @if (editable) {
        <div class="body">
            @if (prototypeModel) {
            <div class="row site" [hidden]="tabSelected != tabSite">
                @for (tag of contentModel?.tags; track tag.key) {
                <app-expansion [status]="model().custome[tag.key]" [meta]="{title: tag.key}">
                    @for (field of tag.value; track field.meta.id) {
                    <app-content-field [formGroup]="formGroup()!" [field]="field" [node]="$any(node())"></app-content-field>
                    }
                </app-expansion>
                }
            </div>
            }
            @if (permissible) {
            <div class="row security" [hidden]="tabSelected != tabSecurity">
                <div class="site-info">
                    <app-security [permission]="$any(permission())" [node]="node()" [formGroup]="formPermission"></app-security>
                </div>
            </div>
            }
            @if (permissible) {
            <div class="row access" [hidden]="tabSelected != tabAccess">
                <div class="site-info">
                    <app-access  [admission]="$any(admission())" [node]="node()" [formGroup]="formAdmission"></app-access>
                </div>
            </div>
            }
        </div>
        @if (prototypeModel) {
        <div class="footer">
            <div class="row">
                @if (tabSelected != tabSecurity && tabSelected != tabAccess) {
                <button type="submit" class="button button-big" [disabled]="disabled">
                    <mat-icon class="regular-icon">save</mat-icon>
                </button>
                }
                @if (tabSelected === tabSecurity) {
                <button type="button" class="button button-big" [disabled]="!formPermission.dirty" (click)="onPermission()">
                    <mat-icon class="regular-icon">lock</mat-icon>
                </button>
                }
                @if (tabSelected === tabAccess) {
                <button type="button" class="button button-big" [disabled]="!formAdmission.dirty" (click)="onAdmission()">
                    <mat-icon class="regular-icon">vpn_key</mat-icon>
                </button>
                }
            </div>
        </div>
        }
        }
    </form>
</div>
}
